(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();
  var loadx_module_default = n;

  // src/js/components/product.js
  var _Product = class {
    static create() {
      const hero = window.Store.app.theBody.querySelector(_Product.param.selector);
      const nav = window.Store.app.theBody.querySelector(_Product.param.nav_selector);
      const features = window.Store.app.theBody.querySelector(_Product.param.features_selector);
      const obj = new _Product(hero, nav, features);
      obj.init();
      return obj;
    }
    constructor(hero, nav, features) {
      this.hero = hero;
      this.nav = nav;
      this.features = features;
    }
    init() {
      this.initHeroScripts();
      this.initHero();
      this.initNav();
      this.initFeatures();
      this.initListeners();
    }
    async initHeroScripts() {
      if (!this.hero.classList.contains(_Product.param.modifiers.has_player)) {
        return false;
      }
      if (!window.Store.components.product.lib_loaded) {
        await loadx_module_default.css(`${window.Store.app.pluginsUrl}/garden-gnome-package/include/ggskin.css`);
        window.Store.components.product.lib_loaded = true;
      }
      const scripts = this.hero.querySelectorAll("script[src]");
      window.startPlayer = null;
      scripts.forEach(async (script) => {
        await loadx_module_default.js(script.src);
      });
      const toEval = this.hero.querySelector("script:not([src])");
      if (toEval) {
        window.eval(toEval.innerText);
      }
      return true;
    }
    initHero() {
      const img = this.hero.querySelector("img");
      if (this.hero.classList.contains(_Product.param.modifiers.has_player) && img) {
        const callback = () => {
          this.hero.classList.add(_Product.param.modifiers.is_player_active);
          img.removeEventListener("click", callback);
          window.startPlayer();
        };
        img.addEventListener("click", callback);
      }
      return true;
    }
    initNav() {
      const self = this;
      const hash = window.location.hash;
      const nav_ul = self.nav.querySelector("ul");
      const nav_select = self.nav.querySelector("select");
      const page_sections = window.Store.app.theContainer.querySelectorAll("section[data-product-section]");
      if (!page_sections) {
        return false;
      }
      page_sections.forEach((section, index) => {
        const section_index = (index + 1).toString().padStart(2, "0");
        const section_anchor = `#${section.id}`;
        const section_title = section.dataset.productSection;
        const selected = section_anchor === hash;
        if (section.id) {
          nav_ul.insertAdjacentHTML("beforeend", `
          <li class="c-navProduct__links--list__item">
            <a href="#" data-product-anchor="${section_anchor}">${section_index} ${section_title}</a>
          </li>`);
          nav_select.insertAdjacentHTML("beforeend", `
          <option value="${section_anchor}"${selected ? " selected" : ""}>${section_index} ${section_title}</option>`);
        }
      });
    }
    initFeatures() {
      const images = this.features.querySelectorAll("img:not(.js-lazy)");
      if (images.length === 0) {
        return false;
      }
      images.forEach((img) => {
        const width = img.getAttribute("width");
        if (width) {
          img.style.maxWidth = `${img.getAttribute("width")}px`;
        }
      });
    }
    initListeners() {
      const li = this.nav.querySelectorAll("ul a");
      const select = this.nav.querySelector("select");
      li.forEach((item) => {
        item.addEventListener("click", this.handleNavUpdate.bind(this));
      });
      select.addEventListener("change", this.handleNavUpdate.bind(this));
    }
    watch(scroll) {
      this.updateSticky();
      this.updateNav();
    }
    handleNavUpdate(e) {
      const element = e.target;
      let hash;
      e.preventDefault();
      if (element.tagName == "SELECT") {
        hash = element.value;
      } else if (element.tagName == "A") {
        hash = element.dataset.productAnchor;
      }
      if (hash.length == 0) {
        window.history.pushState(null, null, " ");
        this.goToSection();
      } else {
        const target = window.Store.app.theContainer.querySelector(hash);
        if (target) {
          window.history.pushState({}, "", hash);
          this.goToSection(target);
        }
      }
    }
    goToSection(target) {
      if (target) {
        window.Store.scrollbar.scrollTo(target, { offset: 100 });
      } else {
        window.Store.scrollbar.scrollTo("top");
      }
    }
    updateSticky() {
      if (this.nav.dataset.scrollSticky === void 0) {
        return false;
      }
      if (this.navIsInView && window.Store.navigation.states.visibility) {
        this.nav.style.setProperty("top", `${window.Store.navigation.height}px`);
      } else {
        this.nav.style.setProperty("top", "0px");
      }
    }
    updateNav() {
      let elements = Array.from(this.nav.querySelectorAll("li"));
      if (window.Store.scrollbar.element.direction == "up") {
        elements = elements.reverse();
      }
      elements.forEach((li) => {
        li.classList.remove(_Product.param.modifiers.is_active);
        const anchor = li.querySelector("a").dataset.productAnchor;
        const target = window.Store.app.theContainer.querySelector(anchor);
        const shouldBeActive = target?.classList.contains(_Product.param.modifiers.is_visible) && !elements.some((e) => e.classList.contains(_Product.param.modifiers.is_active));
        if (shouldBeActive) {
          li.classList.add(_Product.param.modifiers.is_active);
        }
      });
    }
    get navIsInView() {
      const matrix = this.nav.style.transform;
      let y = 0;
      if (matrix !== "" && matrix !== "none") {
        y = matrix.split("(")[1].split(")")[0].split(",")[13];
      }
      return y > 0;
    }
  };
  var Product = _Product;
  __publicField(Product, "param", {
    selector: ".js-heroProduct",
    hero_player_selector: ".js-heroProduct-player",
    nav_selector: ".js-navProduct",
    features_selector: ".js-productFeatures",
    modifiers: {
      is_active: "is-active",
      is_visible: "is-inview",
      has_player: "has-player",
      is_player_active: "is-player-active"
    }
  });
  function render() {
    window.Store.components.product.obj = Product.create();
  }
  window.Store.components.product.render = render;
})();
